export const REAL_APPROVE_TIME = 86399
export const APPROVAL_TIME = 30
export const ACCESS_TOKEN_KEY = 'access_token'
